module.exports = __webpack_public_path__ + "static/media/Original Korean text - 02-16-1999 - Keble College - Philosophy Society QA.7f1011c8.txt";